<template>
  <section class="page warriors container" :class="{'not-loaded': notLoaded}">
    <template v-if="content">
      <div class="warriors__title">
        <AppTitle title="warriors" size="little" :translated="true"/>
      </div>
      <div class="warriors__content">
        <div class="warriors__content__elem" v-for="(item, index) in content" :key="index">
          <AppWarrior :content="item"/>
        </div>
        <div class="warriors__more" v-show="canLoadMore">
          <AppButtonMore text="See more" ref="moreBtn"/>
        </div>
      </div>
      </template>
  </section>
</template>

<script>
  import Page from '@/mixins/Page'

  import AppTitle from '@/components/AppTitle.vue'
  import AppWarrior from '@/components/AppWarrior.vue'
  import AppButtonMore from '@/components/AppButtonMore.vue'

  export default {
    name: 'Warriors',

    mixins: [
        Page
    ],

    components: {
      AppTitle,
      AppWarrior,
      AppButtonMore
    },

    data() {
      return {
        canLoadMore: true
      }
    },

    created()
    {
      this.currentDataPage = 1

      const endpoint = '/wp-json/acf/v3/warriors?per_page=4'

      this.loadDatas(endpoint, (res) => {

        this.content = res
        this.onLoadedDatas()

        setTimeout(() => {
          this.$refs.moreBtn.addEventListeners()
        }, 100)

        this.checkLoadMoreButton(res)
      })
    },

    mounted()
    {

    },

    methods: {
      loadMore()
      {
        if(this.isLoadingMore)
          return

        this.isLoadingMore = true
        this.$refs.moreBtn.isLoading = true

        this.currentDataPage += 1
        const url = process.env.VUE_APP_WP_API + `/wp-json/acf/v3/warriors?per_page=4&page=${this.currentDataPage}`

        fetch(url)
          .then((res) => res.json())
          .then((res) =>
          {
            for(let i = 0; i < res.length; i++)
            {
              this.content.push(res[i])
            }

            this.checkLoadMoreButton(res)

            this.$refs.moreBtn.isLoading = false
            this.isLoadingMore = false
          })
      },

      checkLoadMoreButton(res)
      {
          if(res.length < 4)
          {
            this.canLoadMore = false
          }
          else
          {
            this.canLoadMore = true
          }
      },
    }
  }
</script>

<style lang="stylus">
  .warriors
    transform translate3d(0, 0px, 0)
    transition transform 1.2s $ease-in-out-circ 0s

    &.not-loaded
      transform translate3d(0, 50px, 0)
      transition transform 0s $ease-in-out-circ

      @media(max-width 768px)
        transform translate3d(0, 0px, 0)

    @media(max-width 768px)
      padding-top 30px

  .warriors__title
    z-index 2
    position relative
    // padding-top 250px
    // transform translateY((50px))

    @media(max-width 768px)
      // transform translateY(20px)
      // padding-top 75px

    .title--little
      @media(max-width 768px)
        font-size 36px
        line-height 1
        text-align center

  .warriors__content
    width calc(100% / 36 * 20)
    max-width 1360px
    margin 0 auto
    // transform translateY(-50px)

    @media(max-width 768px)
      width 100%
      transform translateY(-20px)

  .warriors__content__elem
    width 100%
    // margin-bottom 50px
    margin-bottom 150px

    &:nth-last-child(2)
      margin-bottom 50px

    @media(max-width 768px)
      margin-bottom 20px

  .warriors__more
    @media(max-width 768px)
      margin-top 50px
</style>